<template>
  <div class="print-template">
    <!-- 1单个或多个业务销售合同-->
    <div id="part1">
      <h3 style="text-align:center;font-size:20px;font-weight:bold">{{printDetail.titleDetail.name}}</h3>
      <h3 style="text-align:center;font-size:20px;font-weight:bold">销售合同</h3>
      <div style="display:flex;width:100%">
        <el-descriptions :column="1" style="width:49.5%">
          <el-descriptions-item label="需    方：">{{printDetail.customerCompanyDetail.name}}</el-descriptions-item>
          <el-descriptions-item label="供    方：">{{printDetail.titleDetail.name}}</el-descriptions-item>
        </el-descriptions>
        <el-descriptions :column="1">
          <el-descriptions-item label="报价编号 :">{{printDetail.no}}</el-descriptions-item>
        </el-descriptions>
      </div>
      <h4 class="form-title">报价明细：</h4>
    </div>
    <vxe-table
      border
      show-footer
      ref="xTable"
      align="center"
      class="mt-20"
      :print-config="tablePrint"
      keep-source
      auto-resize
      :column-config="{ resizable: true }"
      :footer-method="footerMethod"
      :merge-footer-items="mergeFooterItems"
      :data="printDetail.details"
      >
      <vxe-column field="index" width="50" title="序号">
        <template #default="{ row }">
          {{row.index}}
        </template>
      </vxe-column>
      <vxe-column field="businessName" title="产品名称" min-width="120"/>
      <vxe-column field="businessModel" title="型号" min-width="120"/>
      <vxe-column field="unit" title="单位" width="60">
        <template #default="{ row }">
         {{row.unit || row.businessUnit}}
        </template>
      </vxe-column>
      <vxe-column field="amount" title="数量" width="60">
          <template #default="{ row }">
         {{row.amount || row.businessAmount}}
        </template>
      </vxe-column>
      <vxe-column field="price" title="单价" min-width="100" header-align="center">
         <template #default="{ row }">
          {{$currency(row.price)}}
        </template>
      </vxe-column>
      <vxe-column field="totalPrice" title="总价" min-width="100" header-align="center">
        <template #default="{ row }">
          {{$currency((row.price || 0) * 1 * (row.amount || 0) * 1)}}
        </template>
      </vxe-column>
      <vxe-column field="mark" title="备注" min-width="100" />
    </vxe-table>
    <div id="part2">
      <h4 class="form-title">备注：</h4>
      <pre>{{printDetail.quotationMarkTemplateDetail.mark}} </pre>
      <div style="display:flex;width:100%;border: 1px solid #000;padding:10px">
        <el-descriptions :column="1" style="width:49.5%">
          <el-descriptions-item label="需方签字盖章"></el-descriptions-item>
          <el-descriptions-item label="公司名称：">{{printDetail.customerCompanyDetail.name}}</el-descriptions-item>
          <el-descriptions-item label="地       址：">{{printDetail.receivingEmail}}</el-descriptions-item>
          <el-descriptions-item label="电        话：">{{printDetail.customerCompanyContactDetail.phone}}</el-descriptions-item>
          <el-descriptions-item label="传        真："></el-descriptions-item>
          <el-descriptions-item label="开户银行：">{{printDetail.customerTicketTitleDetail.bank}}</el-descriptions-item>
          <el-descriptions-item label="银行账号：">{{printDetail.customerTicketTitleDetail.account}}</el-descriptions-item>
          <el-descriptions-item label="税        号：">{{printDetail.customerTicketTitleDetail.taxId}}</el-descriptions-item>
          <el-descriptions-item label="委托代表：">{{printDetail.customerCompanyContactDetail.name}}</el-descriptions-item>
          <el-descriptions-item label="日        期：">{{new Date().toLocaleDateString().replace(/\//g, '-')}}</el-descriptions-item>
        </el-descriptions>
        <el-descriptions :column="1" style="position:relative">
          <el-descriptions-item label="供方签字盖章"></el-descriptions-item>
          <el-descriptions-item label="公司名称：">{{printDetail.titleDetail.name}}</el-descriptions-item>
          <el-descriptions-item label="地        址：">{{printDetail.titleDetail.officeAddress}}</el-descriptions-item>
          <el-descriptions-item label="Tel 电话：">{{printDetail.salesManDetail.phone}}</el-descriptions-item>
          <el-descriptions-item label="Line 座机：">{{printDetail.titleDetail.phone}}</el-descriptions-item>
          <el-descriptions-item label="开户银行：">{{printDetail.titleDetail.bank}}</el-descriptions-item>
          <el-descriptions-item label="银行账号：">{{printDetail.titleDetail.account}}</el-descriptions-item>
          <el-descriptions-item label="税        号：">{{printDetail.titleDetail.taxId}}</el-descriptions-item>
          <el-descriptions-item label="委托代表：">{{printDetail.salesManDetail.name}}</el-descriptions-item>
          <el-descriptions-item label="日        期：">{{new Date().toLocaleDateString().replace(/\//g, '-')}}</el-descriptions-item>
          <ZPreview :authSrc="printDetail.titleDetail.sealImg" width="100px" height="100px" class="upload-file_preview" v-if="printDetail.titleDetail.sealImg" />
        </el-descriptions>
      </div>
    </div>
  </div>
</template>
<script lang="ts" >
import { defineComponent, reactive, toRefs } from 'vue'
import mixin from './mixin'
import { VxeTablePropTypes } from 'vxe-table'
import ZPreview from '@/components/common/ZPreview.vue'

export default defineComponent({
  components: {
    ZPreview
  },
  props: {
    detail: { type: Object, required: true, default: () => null }
  },
  setup(props) {
    const dataMap = reactive({
      mergeFooterItems: [
        { row: 0, col: 0, rowspan: 1, colspan: 3 }
      ] as VxeTablePropTypes.MergeFooterItems
    })
    const printMixin = mixin(props, dataMap)

    const footerMethod: VxeTablePropTypes.FooterMethod = ({ columns, data }) => {
      const sums: any[] = []
      columns.forEach((column, columnIndex) => {
        if (columnIndex === 0) {
          sums.push('合计（RMB）')
        } else {
          let sumCell: any = null
          switch (column.field) {
            // case 'price':
            //   sumCell = $currency(sumNum(data, column.field))
            //   break
            case 'totalPrice':
              sumCell = printMixin.sumTotalNum(data, 'price', 'amount')
              break
            case 'amount':
            case 'businessAmount':
              sumCell = printMixin.sumNum(data, column.field, false)
              break
            case 'mark':
              sumCell = printMixin.getTaxRateLabel(props.detail.taxRate)
              break
          }
          sums.push(sumCell)
        }
      })
      // 返回一个二维数组的表尾合计
      return [sums]
    }
    return {
      ...printMixin,
      ...toRefs(dataMap),
      footerMethod
    }
  }
})
</script>
<style lang="scss">
.print-template{
  .table-descri{
    .is-bordered-label{
      width: 180px;
      background: #fff;
    }
  }
  .sign-container-border{
    border: 1px solid rgba(0,0,0,.7);
    height: 0px;
    width: 200px;
    display: inline-block;
  }
  .upload-file_preview{
    position: absolute;
    top: -45px;
    left: 130px;
  }
  pre {
    white-space: pre-wrap;
    word-break: break-all;
    max-width: 100%;
    font-family: inherit;
  }
  #part1, #part2 {
    max-width: 100%;
  }
}

</style>
